import "./Loading.html";
import "./Loading.scss";

import type { IControllerConstructor, Injectable } from "angular";
import { LoadingComponentController } from "./LoadingComponentController";

export class LoadingComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            extraClasses: "<",
            isLoading: "<isLoading",
        };
        this.controller = LoadingComponentController;
        this.templateUrl = "/App/Modules/Gui/Components/Indicators/Loading/Loading.html";
    }
}
